import VueRouter from 'vue-router';
import routes from './routes';
import { store } from '@/store/store';

import axios from '@/axios';

// configure router
const router = new VueRouter({
  // mode: 'history',
  routes, // short for routes: routes
  linkActiveClass: 'active',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
    	return savedPosition
    } else {
    	return { x: 0, y: 0 }
    }
  }
});

router.beforeEach((to, from, next) => {
  store.dispatch('account/fetch');
  if(to.matched.some(record => record.meta.requiresAuth)) {
        if (!store.state.account.user) {
            const path = to !== undefined ? to.fullPath : null;
            console.log('mdmdm')
            next({
                path: '/login',
                params: { 
                	nextUrl: path,
                }
            });
        } else {
        	// to do, check roles
            // let user = JSON.parse(localStorage.getItem('user'))
            // if(to.matched.some(record => record.meta.is_admin)) {
            //     if(user.is_admin == 1){
            //         next()
            //     }
            //     else{
            //         next({ name: 'userboard'})
            //     }
            // }else {
            //     next()
            // }
            next();
        }
    }else {
        next() ;
    }
});

window.addEventListener('online', function(e) {
    // console.log('mh')
    store.dispatch('offline/changeConnectionStatus', true );
}, false);

window.addEventListener('offline', function(e) {
  store.dispatch('offline/changeConnectionStatus', false );
    // console.log('mh')
    // setTimeout(function(){
        // store.dispatch('offline/resolveQueue');
    // },1000)
}, false);


//setup axios -> // TODO -> inseriscilo nell'applicativo per inserire un loading alle richieste
axios.interceptors.request.use(function (config) {
    // TODO -> Centralizing this variable
    const RF_AUTH_ACCESSTOKEN = 'app_lfr_auth'

    if (localStorage.getItem(RF_AUTH_ACCESSTOKEN)){
            config.headers = {
                ...config.headers,
                Authorization: `Bearer ${JSON.parse(localStorage.getItem(RF_AUTH_ACCESSTOKEN))}`,
            }
    }
    if ( store.state.offline.connectionStatus ){ //store.state.offline.connectionStatus
        // else doing nothinh
        return config;
    }else{
        const hashedRequest = Math.random().toString(36).substring(7);
        config.hash = hashedRequest;
        if (config.method !== 'get'){   
            store.dispatch('offline/addRequestToQueue', config );
        }
        return {
            headers: {},
            requestedConfig: config,
            offline: true,
            method: 'get',
            url: ""
        };
    }
  }, function (error) {
    return Promise.reject(error);
  });

// Add a response interceptor
axios.interceptors.response
    .use(function (response) {
        // Do something with response data
        if (!store.state.offline.connectionStatus){
            if (response.config.method === 'get'){
                return store.state.offline.cache[response.config.requestedConfig.url]
            }else{
                //last call, let's hope
                const call = store.state.offline.queue.filter(req => req.hash === response.config.requestedConfig.hash)[0]
                const data = call.data[Object.keys(call.data)[0]];
                
                setTimeout(function(){
                    store.dispatch('alert/warning', 'Sei offline, l\'azione verrà eseguita non appena tornerai online' );
                },300)
                return {
                    data
                }
                
            }
        }else{
            if (response.config.method === 'get'){
                // save the value from cache
                store.dispatch('offline/cacheRequest', response );
            }
        }
        return response;
    }, function (error) {
        if (!store.state.offline.connectionStatus){
            // Se sono offline la risposta dovrà essere fittizzia per ciò che non è una get,
            // e null se è una get 
            if (error.config.method === 'get'){
                return store.state.offline.cache[error.config.requestedConfig.url]
            }
            return {
                data: null , // giusto per non rompere gli update e modules
                status: 500
            }; 
        }
        // non uso router perché potrebber non essere ancora valorizzata la sua history
        const path = window.location.hash.substr(2,1000);
        if (error.response.status === 401 && path !== "login"){
            // //this doesn't work, i think because the route login isn't a base router route
            router.push({
                path: 'login', 
                params: { 
                    nextUrl: path
                }
            });
        }else{            
            return Promise.reject(error.response);

        }
    });



export default router;
